import { queryOptions, useQuery } from "@tanstack/react-query"
import { userCardKeys } from "../model/keys"
import { getUserCards } from "./client"

export function userCardsQueryOptions(userId: number) {
	return queryOptions({
		queryKey: userCardKeys.list(userId),
		queryFn: () => getUserCards(userId),
		staleTime: 60_000,
	})
}

export function useUserCards(userId: number) {
	return useQuery({
		...userCardsQueryOptions(userId),
		select: (cards) => [...cards].reverse(),
	})
}
